import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  documentId: yup.number().required(),
});

var responseSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  doc_type: yup.string().required(),
  expiration_date: yup.string().nullable(),
  description: yup.string().nullable(),
  file_name: yup.string().nullable(),
  file_url: yup.string().nullable(),
  can_edit: yup.boolean().required(),
});

var composeResponse = (res) => {
  return res.data?.data || {};
};

export function usePatientDocumentQuery({ payload = {}, options = {} } = {}) {
  return useQuery({
    queryKey: [QUERY_KEYS.patientDocuments.one, payload.documentId],
    queryFn: async () => {
      const req = requestSchema.validateSync(payload, {
        strict: true,
      });
      const res = await http.get(
        HTTP_ENDPOINTS.patientDocuments.getOne(req.documentId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    ...options,
  });
}
